export default __webpack_public_path__ + "images/mela-purchase/getadditional-ela-ea66943dd3b7a925d2727f6f24cee790.svg";